import { useEffect, useState } from 'react';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import { TablePagination } from '@mui/material';
import styled from '@emotion/styled';
import { useNavigate } from 'react-router-dom';

import api from '../../services/api';
import useCliente from '../../hooks/useCliente';
import { useGlobal } from './../../hooks/useGlobal';

import CriarCobranca from '../CriarCobranca';
import Status from '../Status';
import NaoEncontrado from '../NaoEncontrado';

const TableCellStyled = styled(TableCell)`
  font-family: 'Nunito';
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 50px;
  letter-spacing: 0.005em;
  color: #3F3F55;
  text-transform: capitalize;
  padding: 0px;
`;

const TableCellConteudo = styled(TableCell)`
  font-family: 'Nunito';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 40px;
  letter-spacing: 0.005em;
  padding: 0px;
  color: #747488;
`;

export default function TabelaCliente() {
  // @ts-ignore
  const { currentClientes, setCurrentClientes, setClientes } = useCliente();
  // @ts-ignore
  const { token, setClienteSelecionado } = useGlobal();
  const navigate = useNavigate();
  const [page, setPage] = useState(0);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  useEffect(() => {
    const config = {
      headers: { Authorization: `Bearer ${token}` }
    };

    try {
      const ListarClientes = async () => {
        return await api.get('clientes', config);
      };

      ListarClientes().then(({ data: listaDeClientes }) => {
        listaDeClientes.sort((a,b)=> a.id - b.id)
        setClientes([...listaDeClientes]);
        setCurrentClientes([...listaDeClientes]);
      });
    }
    catch (e) {
      console.error('erro>', e);
    }
  }, []);

  function lidarClienteSelecionado(id, nome) {
    setClienteSelecionado({ id, nome });
    navigate(`${id}`);
  };

  return (
    <TableContainer component={Paper} style={{
      padding: '0px 23px 0 23px', background: '#FFFFFF',
      borderRadius: '30px', height: '76vh', overflow: 'hidden'
    }}>
      <Table>
        <TableHead >
          <TableRow>
            <TableCellStyled align='left'>Cliente</TableCellStyled>
            <TableCellStyled >CPF</TableCellStyled>
            <TableCellStyled >E-mail</TableCellStyled>
            <TableCellStyled >telefone</TableCellStyled>
            <TableCellStyled >status</TableCellStyled>
            <TableCellStyled >criar cobrança</TableCellStyled>
          </TableRow>
        </TableHead>

        <TableBody>
          {!currentClientes.length ?
            <TableRow key={0} >
              <TableCellConteudo colSpan={6} rowSpan={1} >
                <NaoEncontrado />
              </TableCellConteudo>
            </TableRow>
            :
            currentClientes
              .slice(page * 10, page * 10 + 10)
              .map((row, index) => (
                <TableRow key={row.id} >
                  <TableCellConteudo
                    component='th'
                    scope='row'
                    style={{ cursor: 'pointer', }}
                    onClick={() => {
                      /* navigate(`${index}`); */
                      lidarClienteSelecionado(row.id, row.nome)
                    }}
                  >
                    {row.nome}
                  </TableCellConteudo>
                  <TableCellConteudo align='left'>
                    {((cpf) => {
                      cpf = cpf.replace(/\D/g, '');
                      cpf = cpf.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})/g, '$1 $2 $3 $4');

                      return cpf;
                    })(row.cpf)}
                  </TableCellConteudo>
                  <TableCellConteudo align='left'>{row.email}</TableCellConteudo>
                  <TableCellConteudo align='left'>
                    {((Telefone) => {
                      Telefone = Telefone.replace(/\D/g, '');
                      Telefone = Telefone.replace(/^(\d{2})(\d)(\d{4})(\d{4})/g, '$1 $2 $3 $4');

                      return Telefone;
                    })(row.telefone)}
                  </TableCellConteudo>
                  <TableCellConteudo align='left'>
                    <Status statusIndex={row.status} cobranca={false} />
                  </TableCellConteudo>
                  <TableCellConteudo align='left'>
                    <CriarCobranca clienteInfos={row} />
                  </TableCellConteudo>
                </TableRow>
              ))}
        </TableBody>
      </Table>
      <TablePagination
        component='div'
        count={currentClientes.length}
        rowsPerPage={10}
        page={page}
        onPageChange={handleChangePage}
      //onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </TableContainer>

  );
}
